var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 370 341.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;}.cls-4{fill:#d15966;}.cls-5{fill:#d3908e;}.cls-6{fill:#e8c2a8;}.cls-7{fill:#ed1e79;}.cls-8{fill:#ccc;}.cls-9{isolation:isolate;}.cls-10{fill:#0071bc;}.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19{mix-blend-mode:multiply;}.cls-11,.cls-16,.cls-17,.cls-18,.cls-20,.cls-19{opacity:.2;}.cls-11,.cls-21{fill:#6dc0f0;}.cls-22{clip-path:url(#clippath-3);}.cls-23{clip-path:url(#clippath-7);}.cls-24{clip-path:url(#clippath-6);}.cls-2{stroke:#fff;}.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:.85px;}.cls-25{fill:#6d7f8e;}.cls-12{fill:url(#linear-gradient-6);}.cls-12,.cls-13,.cls-14,.cls-15{opacity:.5;}.cls-13{fill:url(#linear-gradient-3);}.cls-14{fill:url(#linear-gradient-4);}.cls-15{fill:url(#linear-gradient-8);}.cls-16{fill:url(#linear-gradient-2);}.cls-17{fill:url(#linear-gradient-5);}.cls-18{fill:url(#linear-gradient-7);}.cls-26,.cls-20{fill:#fff;}.cls-27{fill:#2c496a;}.cls-28{fill:#a58560;}.cls-20{mix-blend-mode:screen;}.cls-29{fill:#295e79;}.cls-30{fill:#f7ec41;}.cls-31{fill:#5c6f7f;}.cls-32{fill:#9ac350;}.cls-33{fill:#8fb435;}.cls-19{fill:url(#linear-gradient);}.cls-34{fill:#d58fb9;}.cls-35{fill:#3c214e;}.cls-36{fill:#e1b89d;}.cls-3{stroke:#3c214e;}.cls-37{clip-path:url(#clippath);}.cls-38{fill:#80623e;}.cls-39{fill:#ca625e;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "341.66 220.22 351.34 310.11 335.48 312.61 317.93 239.4 304.73 312.61 290.52 310.83 290.95 214.76 341.66 220.22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 308.29,
    y1: 220.35,
    x2: 359.09,
    y2: 220.35,
    gradientTransform: "translate(649.95) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 259.67,
    y1: 92.69,
    x2: 350.11,
    y2: 92.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#970000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8e201d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 61.36,
    y1: 305.66,
    x2: 61.36,
    y2: 242.51,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 28.35,
    y1: 220.31,
    x2: 81.63,
    y2: 220.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 185.56,
    cy: 176.91,
    r: 120.4,
    transform: "translate(-70.74 183.03) rotate(-45)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 69.3,
    y1: 110.48,
    x2: 130.98,
    y2: 110.48,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 22.85,
    y1: 184.46,
    x2: 123.27,
    y2: 184.46,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 18.49,
    y1: 87.3,
    x2: 108.39,
    y2: 87.3,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 243.11,
    y1: 185.44,
    x2: 344.87,
    y2: 185.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.72,177.91c17.72-33.42-11.23-69.2-25.09-69.2s-42.8,28.1-25.09,69.2c0-13.85,11.23-15.66,25.09-15.66s25.09,1.8,25.09,15.66Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.58,177.91c14.76-48.44-11.23-69.2-25.09-69.2s-44.83,22.62-25.09,69.2c0-13.85,11.23-15.66,25.09-15.66s25.09,1.8,25.09,15.66Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M338.56,54.06c15.93,17.86,42.63,74.93,17.67,89.43-.67,11.28-13.17,23.78-22.46,11.99-4.29,23.21-85.35,36.52-87.5-19.06-2.14-55.58,92.28-82.36,92.28-82.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "290.83 303.87 290.28 321.94 302.25 323.02 305.96 300.47 290.83 303.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "334.84 304.76 338.77 321.94 351.34 319.76 349.75 302.17 334.84 304.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M369.12,336.26l.87,3.42s-14.46,6.31-31.55-3.26c-.01-1.26-.3-4.45-.3-4.45l30.98,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M337.35,319.07l1.07,15s15.73,6.79,30.7,2.18c-2.07-10.9-13.55-13.24-15.26-13.24l-1.75-4.89-14.76.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M359.89,331.23c-8.62-1.74-11.85-7.05-13.19-12.75l5.42-.35,1.75,4.89c1.71,0,13.19,2.35,15.26,13.24-1.41.43-2.85.76-4.3,1-1.39-3.14-3.35-5.48-4.94-6.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M346.69,318.47c1.35,5.7,4.58,11.01,13.19,12.75,1.59.55,3.55,2.9,4.94,6.04-13.7,2.29-26.4-3.19-26.4-3.19l-1.07-15,9.34-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M337.83,325.77c2.94,2.27,5.24,5.43,5.95,10.08-3.34-.9-5.36-1.77-5.36-1.77l-.59-8.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M361.1,325.35c3.38,1.87,6.93,5.16,8.02,10.91-4.91,1.51-10.1,1.75-14.78,1.4.61-5.93,2.55-10.56,6.76-12.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M358.18,324.03s-4.76,1.43-5.51,4.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M353.86,323.02s-3.72.76-4.61,1.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 353.27,
    y1: 321.35,
    x2: 347.81,
    y2: 321.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M272.25,336.26l-.87,3.42s14.46,6.31,31.55-3.26c.01-1.26.3-4.45.3-4.45l-30.98,4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M304.02,319.07l-1.07,15s-15.73,6.79-30.69,2.18c2.07-10.9,13.55-13.24,15.26-13.24l1.75-4.89,14.76.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M281.48,331.23c8.62-1.74,11.85-7.05,13.19-12.75l-5.42-.35-1.75,4.89c-1.71,0-13.19,2.35-15.26,13.24,1.41.43,2.85.76,4.3,1,1.39-3.14,3.35-5.48,4.94-6.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M294.68,318.47c-1.35,5.7-4.58,11.01-13.19,12.75-1.59.55-3.55,2.9-4.94,6.04,13.7,2.29,26.4-3.19,26.4-3.19l1.07-15-9.34-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M303.54,325.77c-2.94,2.27-5.24,5.43-5.95,10.08,3.34-.9,5.36-1.77,5.36-1.77l.59-8.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M280.27,325.35c-3.38,1.87-6.93,5.16-8.02,10.91,4.91,1.51,10.1,1.75,14.78,1.4-.61-5.93-2.55-10.56-6.76-12.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.19,324.03s4.76,1.43,5.51,4.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M287.51,323.02s3.72.76,4.61,1.61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 288.1,
    y1: 321.35,
    x2: 293.56,
    y2: 321.94
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "341.66 220.22 351.34 310.11 335.48 312.61 317.93 239.4 304.73 312.61 290.52 310.83 290.95 214.76 341.66 220.22"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "296.77 298.87 298.4 307.81 303.95 299.98 296.77 298.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "293.46 286.64 293.32 293.86 300.36 290.25 293.46 286.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "305.28 286.64 305.15 293.86 312.18 290.25 305.28 286.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "300.36 281.08 304.98 274.05 307.31 281.08 300.36 281.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "293.32 277.57 300.36 272.19 292.2 269.41 293.32 277.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "304.74 260.47 306.37 269.41 311.92 261.58 304.74 260.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "296.81 254.76 291.76 262.31 301.19 260.56 296.81 254.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "292.1 227.24 287.04 234.79 296.48 233.03 292.1 227.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "297.28 241.16 289.8 246.32 299.22 248.17 297.28 241.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "301.43 248.24 301.29 255.47 308.33 251.85 301.43 248.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "308.33 242.68 312.95 235.65 315.28 242.68 308.33 242.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "301.29 239.17 308.33 233.79 300.17 231.01 301.29 239.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "327.25 258.5 328.89 267.44 334.44 259.61 327.25 258.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "349.47 259.74 340.99 256.46 344.77 265.29 349.47 259.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "323.94 246.27 323.81 253.5 330.85 249.88 323.94 246.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "308.54 225.43 308.4 232.66 315.44 229.04 308.54 225.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "336.27 225.43 336.13 232.66 343.17 229.04 336.27 225.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "330.85 240.71 335.47 233.68 337.8 240.71 330.85 240.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "323.81 237.2 330.85 231.82 322.69 229.04 323.81 237.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "339.58 300.51 341.21 309.45 346.76 301.62 339.58 300.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "336.27 288.28 336.13 295.51 343.17 291.89 336.27 288.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "343.17 282.72 347.79 275.69 350.12 282.72 343.17 282.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "346.64 297.38 351.26 290.35 353.59 297.38 346.64 297.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "337.33 249.79 341.95 242.76 344.28 249.79 337.33 249.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "327.37 286.24 331.99 279.21 334.32 286.24 327.37 286.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "336.13 279.21 343.17 273.83 335.01 271.05 336.13 279.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "324.73 278.13 331.76 272.75 323.61 269.97 324.73 278.13"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M341.66,220.22s-24.82,14.95-50.74,1.44c.56-7.51-.07-8.29-.07-8.29l50.8,6.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M282.25,212.47c4.69-23.43,11.36-57.59,17.75-65.68,4.16-5.26,19.72-5.99,31.62-3.87,9.34,1.67,16.6,9.3,17.5,18.75,0,.06.01.12.02.18,1.09,12.11-4.7,18.74-7.1,30.96-1.15,5.86-1.87,14.75,1.14,26.49-4.69,7.67-49,5.54-60.93-6.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.62,216.95s-17.74,7.35-47.81,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.13,136.42l1.07,8.07s-7.24,7.64-17.26,0c-1.28-5.73-1.28-8.07-1.28-8.07h17.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M259.67,90.84c0,36.1,16.39,62.99,65.33,48.77,50.5-14.67,26.92-65.23,17.04-74.85-13.44-14.73-34.38-19.81-52.45-12.84-16.23,6.25-27.74,21.28-29.92,38.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M270.04,119.51c1.45,5.48,4.45,10.78-1.36,12.31-5.81,1.54-11.7-1.66-13.15-7.15-1.45-5.48,2.09-11.17,7.91-12.71,5.81-1.54,5.16,2.06,6.61,7.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M309.65,103.14c1.62,6.12-2.04,12.4-8.16,14.02-6.12,1.62-12.4-2.04-14.02-8.16-1.62-6.12,2.04-12.4,8.16-14.02,6.12-1.62,12.4,2.04,14.02,8.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M347.8,93.06c1.62,6.12-2.04,12.4-8.16,14.02-6.12,1.62-12.4-2.04-14.02-8.16-1.62-6.12,2.04-12.4,8.16-14.02,6.12-1.62,12.4,2.04,14.02,8.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.94,104.15s2.71-2.41,4.69.25c1.66,2.24-1.59,6.11-1.59,6.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M311.68,120.31c1.63,7.91,7.86,3.78,9.94-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M345.21,95.99c-6.29-8.55-18.79-6.48-16.29,4.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M307.13,106.82c-2.32-6.52-19.28-10.14-15.89,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M326.5,139.16s-7.65,2.52-12.08,2.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M308.67,143.49c-4.18,13.42,6.82,9.84,9.27,4.4,1.55,10.81,15.96,5.14,11.44-5.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M317.93,147.89s-8.85,27.47-14.54,73.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M261.88,111.62s5.1,30.79,13.32,30.94c3.93.07.61-41.62-3.09-49.35,7.37,9.06,41.17-7.37,42.31-33.44,17.21,17.86,23.47,25.03,35.69,17.52-3.49-34.3-39.38-43.23-66.25-27.16-24.19-3.83-50.66,32.27-21.98,61.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M350.11,80.12c-.14-1.42-.36-2.78-.62-4.11-2.53-5.15-5.32-9.16-7.46-11.24-13.44-14.73-34.38-19.81-52.45-12.84-16.23,6.25-27.74,21.28-29.92,38.92,0,19.71,4.88,36.67,17.29,45.7.18-12.67-2.24-35.05-4.85-40.5,7.37,9.06,41.17-7.37,42.31-33.44,17.21,17.86,23.47,25.03,35.69,17.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M311.68,58.34s-12.55,28.57-31.12,25.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310.66,51.2s18.3.36,26.24,17.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.39,48.93s10.81-5.94,23.81,2.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.39,56.51s-8.55,16.84-25.69,18.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.5,51.2s-6.81,20.56-27.02,20.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M332.24,56.51s9.1.63,12.64,14.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M304.9,122.5c.51,1.48-1.74,3.6-5.01,4.72-3.28,1.13-6.35.84-6.85-.65s1.74-3.6,5.01-4.72c3.28-1.13,6.35-.84,6.85.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M348.55,111.84c.51,1.48-1.74,3.6-5.01,4.72-3.28,1.13-6.35.84-6.85-.65-.51-1.48,1.74-3.6,5.01-4.72,3.28-1.13,6.35-.84,6.85.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M.03,336.67l-.03,2.98s15.51,5.11,31.98-2.84c0-1.14.28-4.12.28-4.12L.03,336.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M33.12,318.92l-1.14,15.76s-15.76,5.96-31.95,1.99c-.71-10.65,11.93-13.21,13.92-13.21l1.28-5.68,17.89,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M8.69,331.98c9.13-1.71,12.14-7.24,13.14-13.78l-6.61-.42-1.28,5.68c-1.99,0-14.63,2.56-13.92,13.21,1.57.39,3.14.68,4.7.89.76-2.83,2.36-5.04,3.97-5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M21.83,318.2c-1,6.54-4.01,12.07-13.14,13.78-1.6.53-3.2,2.74-3.97,5.58,14.41,1.98,27.26-2.88,27.26-2.88l1.14-15.76-11.29-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M32.58,326.45c-3.26,2.36-5.66,5.5-6.18,9.85,3.47-.82,5.58-1.61,5.58-1.61l.59-8.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M6.09,326c-3.37,1.96-6.42,5.28-6.06,10.66,5.44,1.34,10.82,1.55,15.58,1.24-1.5-5.44-4.4-10.06-9.52-11.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M90.86,334.86l-.98,3s-18.16,5.14-32.92-2.86c.39-1.14,1.1-4.14,1.1-4.14l32.8,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M61.83,317l-4.15,15.86s14.67,6,33.17,2c4.37-10.72-8.15-13.29-10.26-13.29l.57-5.72-19.34,1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M83.27,330.14c-9.09-1.72-10.4-7.29-9.24-13.87l7.14-.42-.57,5.72c2.11,0,14.63,2.57,10.26,13.29-1.8.39-3.56.68-5.28.9.15-2.85-.79-5.07-2.31-5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M74.03,316.28c-1.16,6.58.15,12.14,9.24,13.87,1.52.54,2.46,2.76,2.31,5.61-15.94,1.99-27.9-2.9-27.9-2.9l4.15-15.86,12.2-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M59.85,324.57c2.65,2.37,4.12,5.54,3.2,9.91-3.4-.82-5.37-1.62-5.37-1.62l2.17-8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M88.05,324.13c2.9,1.97,5.01,5.31,2.8,10.73-6.21,1.34-11.99,1.56-16.93,1.25,3.43-5.47,8.08-10.12,14.13-11.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M80.27,204.59l-51.13,12.36-14.66,88.69c9.61,1.14,18.95,1.95,28.64,1.17,7.73-28.46,14.99-64.3,14.99-64.3l-.36,63.15c8.82-.07,17.62-1.23,26.31-3.31.17-61.67-3.79-97.76-3.79-97.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M58.12,242.51l-.36,63.15c2.41-.02,4.81-.13,7.22-.3l-6.85-62.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.4,236.44s15.17,4.83,15.16-14.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "39.86 307.12 55.93 241.73 60.5 241.01 60.5 221.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M57.75,305.66l-.07,12.12c10.23,1.14,21.88-.36,26.28-1.93.06-4.63.09-9.13.1-13.51-8.69,2.08-17.49,3.24-26.31,3.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M28.35,221.73s27.36,12.74,53.28-.77l-.56-7.51-52.72,8.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M85.81,212.47c-4.69-23.43-11.36-57.59-17.75-65.68-6.39-8.1-39.77-5.47-45.3,1.78-1.4,2.82-3.31,7.43-3.83,13.28-1.09,12.11,4.7,18.74,7.1,30.96,1.15,5.86,1.87,14.75-1.14,26.49,4.69,7.67,49,5.54,60.93-6.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.19,142.79s1.37,5.92,11.35,7.12,12.38-6.42,12.38-6.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.44,216.95s17.74,7.35,47.81,0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 185.56,
    cy: 176.91,
    r: 120.4,
    transform: "translate(-70.74 183.03) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M193.91,76.53c-6.68-4.29-10.97.95-18.12,0-7.15-.95-25.75-8.58-29.56,2.38,0,0-2.86-2.38,3.34,5.72,6.2,8.11,10.49,13.83,15.74,9.54,5.25-4.29,11.92-11.92,19.55-10.49s15.74-2.86,9.06-7.15ZM88.05,148.54c10.01,3.81,7.15-.48,10.97-9.54,3.81-9.06,5.72-5.25,15.26-9.06,9.54-3.81,9.54-6.2,7.15-13.83-2.38-7.63,3.34-1.43,11.92-1.91,8.58-.48,10.01-2.86,13.83-11.92,3.81-9.06-12.87-6.68-23.37-5.72-10.49.95-6.2-6.2-4.29-11.44,1.91-5.25-20.5-1.91-20.5-1.91l-39.1,67.23c4.29-4.29,18.12-5.72,28.13-1.91ZM140.5,200.51c-12.4-4.77-8.11-9.06-14.78-16.69-6.68-7.63-18.6-1.43-21.46-3.34-2.86-1.91-13.83,5.72-18.6,1.43-4.77-4.29-.48-7.15,3.81-12.87,4.29-5.72,6.2-6.68,3.81-9.06s-7.63,4.29-12.4,6.2c-4.77,1.91-1.91-1.91-11.44-4.29-9.54-2.38-12.87-.48-12.87-.48l-.95,19.07s15.74,1.43,20.5,1.43,6.68,4.29,10.49,6.68c3.81,2.38,0,10.97-5.72,16.69-5.72,5.72,0,7.63,3.81,10.97,3.81,3.34,6.68,7.15,12.87,15.26,6.2,8.11,7.63,13.83,13.35,32.9,5.72,19.07,4.77,20.5,7.63,23.37,2.86,2.86,10.01,4.77,10.01,4.77,0,0,2.38-10.49,2.86-15.74.48-5.25,8.11-12.87,12.87-18.6,4.77-5.72,6.2-10.49,1.43-19.07-4.77-8.58,1.91-9.06,9.06-19.07,7.15-10.01-1.91-14.78-14.31-19.55ZM274.02,83.21s-2.86,13.83-11.44,11.44c-8.58-2.38-9.54-5.25-16.69,1.43-7.15,6.68-11.44,9.54-19.55,10.49-8.11.95-14.31,3.34-12.4,8.11,1.91,4.77,1.91,11.44,13.35,9.54s9.54-1.43,17.64,1.91c8.11,3.34,14.78-10.97,22.41,3.34.64,1.21,1.41,2.43,2.28,3.63,2.46,3.42-1.06,7.97-4.99,6.44-.05-.02-.1-.04-.15-.06-9.54-3.81-9.54-5.72-15.74-2.86-6.2,2.86-12.87.95-16.21-2.38s-2.86-7.15-9.54-1.91c-6.68,5.25-7.63,2.86-15.26,8.58-7.63,5.72-12.4,7.15-10.49,13.35,1.91,6.2-1.91,9.06,5.25,15.26,7.15,6.2,12.87,7.15,20.5,12.87,7.63,5.72,10.01-.95,13.83,14.31,3.81,15.26.48,20.98,6.68,30.52,6.2,9.54,8.11,19.07,14.78,19.07s10.49-2.86,12.87-9.54c2.38-6.68.95-11.44,6.2-17.17,5.25-5.72,1.91-15.26,8.11-21.46,6.2-6.2,16.69-9.06,7.15-17.64-9.54-8.58-11.92-7.15-15.26-11.92s-6.68-6.2,0-12.4c3.55-3.3,6.43-6.33,8.06-9.37,9.08,4.85,19.1,5.92,25.32-1.59l-36.72-61.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M193.91,76.53c-6.68-4.29-10.97.95-18.12,0-7.15-.95-25.75-8.58-29.56,2.38,0,0-.01,4.31,3.34,5.72,9.41,3.95,10.49,13.83,15.74,9.54,5.25-4.29,11.92-11.92,19.55-10.49s15.74-2.86,9.06-7.15ZM88.05,148.54c10.01,3.81,7.15-.48,10.97-9.54,3.81-9.06,5.72-5.25,15.26-9.06,9.54-3.81,9.54-6.2,7.15-13.83-2.38-7.63,3.34-1.43,11.92-1.91,8.58-.48,10.01-2.86,13.83-11.92,3.81-9.06-12.87-6.68-23.37-5.72-10.49.95-6.2-6.2-4.29-11.44,1.91-5.25-20.5-1.91-20.5-1.91l-39.1,67.23c4.29-4.29,18.12-5.72,28.13-1.91ZM140.5,200.51c-12.4-4.77-8.11-9.06-14.78-16.69-6.68-7.63-18.6-1.43-21.46-3.34-2.86-1.91-13.83,5.72-18.6,1.43-4.77-4.29-.48-7.15,3.81-12.87,4.29-5.72,6.2-6.68,3.81-9.06s-7.63,4.29-12.4,6.2c-4.77,1.91-1.91-1.91-11.44-4.29-9.54-2.38-12.87-.48-12.87-.48l-.95,19.07s15.74,1.43,20.5,1.43,6.68,4.29,10.49,6.68c3.81,2.38,0,10.97-5.72,16.69-5.72,5.72,0,7.63,3.81,10.97,3.81,3.34,6.68,7.15,12.87,15.26,6.2,8.11,7.63,13.83,13.35,32.9,5.72,19.07,4.77,20.5,7.63,23.37,2.86,2.86,10.01,4.77,10.01,4.77,0,0,2.38-10.49,2.86-15.74.48-5.25,8.11-12.87,12.87-18.6,4.77-5.72,6.2-10.49,1.43-19.07-4.77-8.58,1.91-9.06,9.06-19.07,7.15-10.01-1.91-14.78-14.31-19.55ZM274.02,83.21s-2.86,13.83-11.44,11.44c-8.58-2.38-9.54-5.25-16.69,1.43-7.15,6.68-11.44,9.54-19.55,10.49-8.11.95-14.31,3.34-12.4,8.11,1.91,4.77,1.91,11.44,13.35,9.54s9.54-1.43,17.64,1.91c8.11,3.34,14.78-10.97,22.41,3.34.64,1.21,1.41,2.43,2.28,3.63,2.46,3.42-1.06,7.97-4.99,6.44-.05-.02-.1-.04-.15-.06-9.54-3.81-9.54-5.72-15.74-2.86-6.2,2.86-12.87.95-16.21-2.38s-2.86-7.15-9.54-1.91c-6.68,5.25-7.63,2.86-15.26,8.58-7.63,5.72-12.4,7.15-10.49,13.35,1.91,6.2-1.91,9.06,5.25,15.26,7.15,6.2,12.87,7.15,20.5,12.87,7.63,5.72,10.01-.95,13.83,14.31,3.81,15.26.48,20.98,6.68,30.52,6.2,9.54,8.11,19.07,14.78,19.07s10.49-2.86,12.87-9.54c2.38-6.68.95-11.44,6.2-17.17,5.25-5.72,1.91-15.26,8.11-21.46,6.2-6.2,16.69-9.06,7.15-17.64-9.54-8.58-11.92-7.15-15.26-11.92s-6.68-6.2,0-12.4c3.55-3.3,6.43-6.33,8.06-9.37,9.08,4.85,19.1,5.92,25.32-1.59l-36.72-61.99Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M69.3,145.54c15.38,1,26.09-3.04,33.27-10.34.51.43,1.21.79,2.16,1.06,5.76,1.64,11.73-1.01,13.37-5.93.91-2.74.3-5.61-1.41-7.92.27-.72.51-1.47.72-2.25,10.17,12.96,12.31-12.04,5.65-26.76,4.58,2.01,14.67-2.45,1.1-9.32,7.3-1.26,5.07-16.25-3.35-4.07.16-1.46.07-2.98-.21-4.49-24.85,15.95-43.44,40.79-51.31,70.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M299.28,137.28c0,.14,0,.27,0,.41,0,66.5-53.91,120.4-120.4,120.4-52.61,0-97.33-33.75-113.72-80.77.22,66.31,54.04,120,120.4,120s120.4-53.91,120.4-120.4c0-13.89-2.36-27.22-6.68-39.63Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 223.59,
    cy: 80.67,
    rx: 9.67,
    ry: 34.91,
    transform: "translate(67.64 260.05) rotate(-68.83)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M39.24,176.02c2-1,5.28-2.98,8.1-6.6,4.56-5.87,4.94-12.22,4.96-14.49-18.6-16.62-18.85-6.6-22.68,0-3.83,6.6-10.83,13.85,9.63,21.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M24.7,165.24l80.31,50.42c3.74,14.02,7.26,7.58,4.77.22,7.26,8.65,13.07,2.1,2.91-3.49,15.36,2.85,12.45-5.17,1.04-4.42,11-3.11,10.37-13.66-2.49-4,4.15-10.41-3.11-9.47-4.79-.47-34.22-24.75-73.44-58.54-73.44-58.54,0,0-15.36,5.03-8.3,20.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M24.75,165.15l82.44,46.65c3.83,13.85,7.46,7.24,4.9,0,7.46,8.31,13.42,1.49,2.98-3.62,15.76,2.13,12.78-5.75,1.07-4.47,11.29-3.62,10.65-14.15-2.56-3.88,4.26-10.61-3.19-9.33-4.92-.25-35.13-23.14-75.39-55.1-75.39-55.1,0,0-15.76,5.75-8.52,20.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.24,176.02s2.25-16.4,13.06-21.09c-18.6-16.62-27.33-11.72-31.16-5.11-3.83,6.6-2.34,18.96,18.11,26.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.85,165.46c2.97,3.87,8.14,7.63,16.39,10.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.3,154.93c-6.01-5.37-10.99-8.49-15.1-10.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.15,324.57s5.71,1.54,6.96,4.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.95,323.46s4.42.84,5.55,1.77"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 14.37,
    y1: 321.58,
    x2: 20.86,
    y2: 322.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.1,327.67s3.88-4.49,9.06-4.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.48,324.35s3.46-2.68,6.12-2.78"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 73.67,
    y1: 319.85,
    x2: 80.86,
    y2: 318.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M41.92,136.42l-1.07,8.07s7.24,7.64,17.26,0c1.28-5.73,1.28-8.07,1.28-8.07h-17.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M19.88,66.24s-18.69,13.63-9.95,15.42c-5.98,12.09-2.38,19.56-.23,20-2.98,14.51,5.49,19.17,12.73,9.28s27.02-40.42-2.55-44.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.39,90.84c0,36.1-16.39,62.99-65.33,48.77-50.5-14.67-26.92-65.23-17.04-74.85,13.44-14.73,34.38-19.81,52.45-12.84,16.23,6.25,27.74,21.28,29.92,38.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M78.47,51.92c-18.07-6.96-39.01-1.88-52.45,12.84-2.16,2.1-4.98,6.17-7.53,11.39,5.68,3.21,17.81,2.73,34.76-5.71-17.45,12.15,23.3,21.61,38.01,11.37-5.2,9.26-1.77,18.95,4.85,9.05-9.07,17.12-.99,29.46,3.7,24.01-.82,5.87-.3,9.31.89,10.88,5.41-9.25,7.69-21.44,7.69-34.91-2.18-17.64-13.69-32.67-29.92-38.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98.02,119.51c-1.45,5.48-4.45,10.78,1.36,12.31,5.81,1.54,11.7-1.66,13.15-7.15,1.45-5.48-2.09-11.17-7.91-12.71-5.81-1.54-5.16,2.06-6.61,7.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M58.41,103.14c-1.62,6.12,2.04,12.4,8.16,14.02,6.12,1.62,12.4-2.04,14.02-8.16,1.62-6.12-2.04-12.4-8.16-14.02-6.12-1.62-12.4,2.04-14.02,8.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M20.26,93.06c-1.62,6.12,2.04,12.4,8.16,14.02,6.12,1.62,12.4-2.04,14.02-8.16,1.62-6.12-2.04-12.4-8.16-14.02-6.12-1.62-12.4,2.04-14.02,8.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.12,104.15s-2.71-2.41-4.69.25c-1.66,2.24,1.59,6.11,1.59,6.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.38,120.31c-1.63,7.91-7.86,3.78-9.94-2.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M111.42,113.61c-2.76,13.42-14.07,19.38-11.4.26-4.65,5.27-12.62-7.6-3.61-24.44-6.57,9.67-9.94-.29-4.78-9.38-14.58,9.61-54.88-2-37.58-13.39-31.07,14.2-45.79,1.72-33.86-9.69-25.15,2.4,6.35-24.33,48.85-13.28-19.58-9.91,9.84-16.2,31.14,11.57-.57-10.96,13.76,3.12,12.97,15.14,7.82-13.52,10.72,2.11,3.49,4.03,13.93,6.27,3.97,11.81-.7,10,7.35,15.36,6.32,42.84-4.53,29.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M80.67,63.72c-1.19-1.8-20.09-1.78-28.55,3.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.51,54.97s-26.65-9.32-51.31,2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.33,72.41s-18.44-5.33-29.23.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M90.76,64.87s-16.27-12.59-33.84-6.95c-17.57,5.63-16.83,3.89-16.83,3.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.76,55.17s-9.49-7.44-24.59-11.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.54,71.23s-1.17-13.5-13.43-22.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.9,79.94s-1.25,10.86-7.52,13.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.69,94.91s-1.18,15.35-6.67,18.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.1,96.23s1.99,10.65-2.06,18.96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M110.31,77.31s8.97,14.65,7.24,23.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.85,95.99c6.29-8.55,18.79-6.48,16.29,4.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M60.93,106.82c2.32-6.52,19.28-10.14,15.89,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M14.48,305.64l-2.38,14.41s18.04,1.93,27.27-.2c1.25-4.03,2.51-8.44,3.76-13.04-9.69.78-19.03-.03-28.64-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M35.88,174.71c-.13-9.05,2.13-19.18,14.3-21.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.56,139.16s7.65,2.52,12.08,2.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M341.88,149.47c-.06-.06-.12-.13-.18-.19-3.05-3.15-8.15-3.19-11.67-.25-10.63,8.87-37.08,30.64-62.51,49.25l-.82-1.22-1.25,1.32.51,1.05c-.22.16-.44.32-.66.48l-.63-1.49-1.87,1.5.43,1.48c-1.01.73-2.03,1.46-3.03,2.17-1.71-9-9.1-9.93-4.87.48-13.08-9.66-13.72.9-2.53,4-11.6-.73-14.56,7.29,1.05,4.42-10.34,5.6-4.43,12.14,2.95,3.48-2.53,7.36,1.06,13.8,4.85-.23l4.89-3.02.61,2.1,3.42-2.36-.75-1.77,1.19-.74.8,1.66,2.8-2.65-.59-.88,64.73-40.02c6.58-4.07,8.17-13.14,3.1-18.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M338.72,167.75l-77.86,44.06c-3.83,13.85-7.46,7.24-4.9,0-7.46,8.31-13.42,1.49-2.98-3.62-15.76,2.13-12.78-5.75-1.07-4.47-11.29-3.62-10.65-14.15,2.56-3.88-4.26-10.61,3.19-9.33,4.92-.25,27.76-18.29,58.72-42.07,70.49-51.25,3.56-2.78,8.7-2.5,11.79.8.06.07.12.13.18.2,5.12,5.66,3.51,14.66-3.13,18.42Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 336.46,
    cy: 157.05,
    r: 12.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M349.01,159.63c-1.19,5.84-6.36,10.23-12.55,10.23-7.08,0-12.81-5.74-12.81-12.81s5.74-12.81,12.81-12.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M317.93,157.05l6.78-5.32s6.21,16.9,12.72,18.09c-5.1,3.51-7.95,5.48-7.95,5.48,0,0-13.46-7.21-11.55-18.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M317.93,157.05l6.78-5.32s6.21,16.9,12.72,18.09c-5.1,3.51-7.95,5.48-7.95,5.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 290.28,
    y1: 308.33,
    x2: 305.3,
    y2: 309.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 334.59,
    y1: 308.89,
    x2: 350.54,
    y2: 306.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M355.41,333.33s5.12-1.5,6.11,4.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M356.86,329.08s7.95-.92,7.96,8.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M285.95,332.28s-3.36-.18-4.64,5.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.63,328.15s-7.35,3.41-7.08,9.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "262.02 196.06 266.42 211.14 269.88 208.94 263.91 194.64 262.02 196.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "264.69 194.64 271.13 208.15 273.96 205.64 265.95 193.38 264.69 194.64"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 143.63,
    cy: 149.62,
    r: 25.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 143.63,
    cy: 149.62,
    r: 18.29
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 227.49,
    cy: 149.62,
    r: 25.09
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 227.49,
    cy: 149.62,
    r: 18.29
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M172.29,180.18c4.71,26.4,24.8,14.61,23.71,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.04,175.02c0,2.85-6.99,5.16-15.61,5.16s-15.61-2.31-15.61-5.16,6.99-5.16,15.61-5.16,15.61,2.31,15.61,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M242.1,175.02c0,2.85-6.99,5.16-15.61,5.16s-15.61-2.31-15.61-5.16,6.99-5.16,15.61-5.16,15.61,2.31,15.61,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.93,62.66s-11.54-16.37-2.15-19.43c9.39-3.06,9.39,7.97,9.39,7.97,0,0,2.72-10.1,11.26-7.97,8.54,2.13-3.53,21.58-18.5,19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.83,21.98s-11.54-16.37-2.15-19.43c9.39-3.06,9.39,7.97,9.39,7.97,0,0,2.72-10.1,11.26-7.97,8.54,2.13-3.53,21.58-18.5,19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.29,47.39s-14.81-10.36-8.29-13.61c5.46-2.73,8.26,3.22,8.26,3.22,0,0-.94-5.77,4.44-5.64,5.02.13,4.85,7.65-4.41,16.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.59,27.01s-10.79-14.5-3.58-15.53c6.04-.86,6.83,5.66,6.83,5.66,0,0,.92-5.78,5.99-3.95,4.72,1.7,2.19,8.79-9.24,13.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M260.1,64.81s-15.98-12.08-7.97-17.85c8.01-5.77,11.37,4.73,11.37,4.73,0,0-.48-10.45,8.3-11.02,8.78-.57,3.21,21.64-11.7,24.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M280.02,24.15s-15.98-12.08-7.97-17.85c8.01-5.77,11.37,4.73,11.37,4.73,0,0-.48-10.45,8.3-11.02,8.78-.57,3.21,21.64-11.7,24.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M289.27,40.04s-9.6-6.87-5.32-8.95c3.59-1.74,5.38,2.16,5.38,2.16,0,0-.57-3.78,2.94-3.65,3.28.12,3.11,5.04-3,10.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M262.31,39.39s-14.7-10.52-8.14-13.7c5.49-2.66,8.23,3.31,8.23,3.31,0,0-.88-5.78,4.5-5.59,5.01.18,4.76,7.71-4.59,15.98Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanet);
export default __webpack_public_path__ + "static/media/planet.586f6e32e5bf31419a95e23a009c7127.svg";
export { ForwardRef as ReactComponent };